<script>
    import NavigationItem from './NavigationItem.svelte';

    export let items = [];
    export let editor;
    export let level = 0;
</script>

<div class="navigation-tree" role="tree" data-level={level}>
    {#each items as item (item.id)}
        <NavigationItem {item} {editor} {level} />
    {/each}
</div>

<style>
    .navigation-tree {
        display: flex;
        flex-direction: column;
    }

    .navigation-tree[data-level="0"] {
        padding: 0;
    }
</style>